import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'button']

  getTextToCopy() {
    const target = this.inputTarget
    // Support input elements
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
      return target.value
    }
    // Support data attribute
    if (target.dataset.value) {
      return target.dataset.value
    }
    // Fallback to text content
    return target.textContent.trim()
  }

  async copy() {
    const textToCopy = this.getTextToCopy()
    
    try {
      // Try the modern Clipboard API first
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(textToCopy)
        this.showVisualFeedback(this.buttonTarget)
        return
      }
    } catch (err) {
      console.log('Clipboard API failed, trying fallback:', err)
    }

    // Fallback for mobile browsers and older browsers
    try {
      const target = this.inputTarget
      // Only use input-specific methods if it's actually an input
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
        // Select the input text
        target.select()
        target.setSelectionRange(0, 99999)
        
        // Focus the input to ensure selection works on mobile
        target.focus()
        
        // Use the deprecated but still functional execCommand as fallback
        const successful = document.execCommand('copy')
        if (successful) {
          this.showVisualFeedback(this.buttonTarget)
        } else {
          throw new Error('execCommand copy failed')
        }
      } else {
        // For non-input elements, create a temporary input to use execCommand
        const tempInput = document.createElement('input')
        tempInput.style.position = 'fixed'
        tempInput.style.opacity = '0'
        tempInput.value = textToCopy
        document.body.appendChild(tempInput)
        tempInput.select()
        tempInput.setSelectionRange(0, 99999)
        const successful = document.execCommand('copy')
        document.body.removeChild(tempInput)
        
        if (successful) {
          this.showVisualFeedback(this.buttonTarget)
        } else {
          throw new Error('execCommand copy failed')
        }
      }
    } catch (fallbackErr) {
      console.error('Unable to copy to clipboard:', fallbackErr)
    }
  }

  showVisualFeedback(button) {
    // Change to check icon
    button.innerHTML = `<svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                         <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                       </svg>`
    
    // Reset to copy icon after 1 second
    setTimeout(() => {
      button.innerHTML = `<svg class="w-4 h-4" viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.0549 0H8.52325C7.85575 0 7.22742 0.2496 6.75575 0.7032L4.39909 2.9656C3.92658 3.4184 3.66659 4.0216 3.66659 4.6632V11.2C3.66659 12.0824 4.38909 12.8 5.27825 12.8H12.0558C12.9441 12.8 13.6666 12.0824 13.6666 11.2V1.6C13.6666 0.7176 12.9441 0 12.0549 0ZM7.83325 1.9312V4H5.67825L7.83325 1.9312ZM5.33325 11.2V5.6H7.83325C8.75242 5.6 9.49992 4.8824 9.49992 4V1.5944L11.9949 1.5792C11.9949 1.5792 11.9999 1.5856 11.9999 1.6L12.0549 11.2H5.33325Z" fill="currentColor"/>
                            <path d="M8.66658 13.6V14.4H1.99992L1.99909 4.8H2.83325V3.2H1.99992C1.08075 3.2 0.333252 3.9176 0.333252 4.8V14.4C0.333252 15.2824 1.05575 16 1.94492 16H8.69492C9.14992 16 9.57575 15.8272 9.89242 15.5128C10.1933 15.2144 10.3174 14.828 10.3291 14.4L10.3333 13.6H8.66658Z" fill="currentColor"/>
                          </svg>`
    }, 1000)
  }
}
